// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"CreditsNotificationModal_modalContent__A3cQ0"};